import React from 'react'
import { useIsOffline } from '@oneblink/apps-react'

export default function useOfflineUpdateControlledForm(fn: () => void) {
  const isOffline = useIsOffline()
  const [isOfflineCache, setIsOfflineCache] = React.useState(isOffline)

  React.useEffect(() => {
    if (isOfflineCache !== isOffline) {
      fn()
      setIsOfflineCache(isOffline)
    }
  }, [fn, isOfflineCache, isOffline])
}
